import axios from 'axios';
import { tokenRefresh } from 'src/api/auth';
import { ENV } from 'src/utils/env';

axios.defaults.withCredentials = true

/*
    Axios instance intended to be used for authentication processes.
    The main axios instance below uses this axios instance to try to refresh
    if the access token has expired.

    Related, the AuthContext instances attaches an interceptor to this instance
    to automatically logout if refresh fails, i.e. the refresh token has expired too.
    
    But failed refresh and say, a failed login both returns 403 status code.
    So we set the 'noExpire' option here to be used for all authentication processes
    and we explicitly set the call for token refresh to have 'noExpire' set to 'false'
    so it can trigger expiration.
*/
export const authAxios = axios.create({
    baseURL: ENV.BACKEND_URL,
    withCredentials: true,
    noExpire: true
});

/*
    Axios instance intended to be used for API calls other than authentication processes.
*/
const axiosInstance = axios.create({
    baseURL: ENV.BACKEND_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json'
    }
});

axiosInstance.interceptors.response.use((response) => response,
    async (error) => {
        const originalRequest = error?.config;
        const response = error?.response;
        const firstError = response?.data?.errors?.[0];
        // If error reason was unauthorized access try to refresh the access token
        // _.retry variable is to only try to refresh once
        if (originalRequest && !originalRequest.retry && response?.status === 403 && firstError?.title === 'NotAuthenticated') {
            originalRequest.retry = true;
            // Where the token refresh happens
            await tokenRefresh.func();
            // Retry the original request
            return axiosInstance(originalRequest);
        }
        // Error cause was different, no need to try to refresh
        return Promise.reject(error);
    });

export default axiosInstance;
